import React from "react";
import { Link } from "react-router-dom";
import { Plane, Route, Mountain, Briefcase, Clock, Users, ShieldCheck, ArrowRight } from "lucide-react";
import { ALL_SERVICES } from "../data/pricing";
import { useLang } from "../i18n/LanguageContext";
import Reveal from "./Reveal";

const ICONS = { plane: Plane, route: Route, mountain: Mountain, briefcase: Briefcase, clock: Clock, users: Users, shield: ShieldCheck };

const ServicesDetail = () => {
  const { t } = useLang();
  return (
    <section id="services-detail" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
      <Reveal className="max-w-2xl mb-14">
        <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">{t("services.kicker")}</p>
        <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#0B1533]">{t("services.title")}</h2>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {ALL_SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon] || Plane;
          return (
            <Reveal key={s.title} delay={(i % 4) * 80}>
              <Link to={s.link} data-testid={`service-detail-${i}`} className="group flex flex-col h-full rounded-3xl border border-[#E9E5DE] bg-white p-7 hover:border-[#2B4BFF] hover:elev-soft transition-all duration-200">
                <div className="w-11 h-11 rounded-full bg-[#EEF1FF] flex items-center justify-center mb-4">
                  <Icon size={20} className="text-[#2B4BFF]" />
                </div>
                <h3 className="font-heading font-semibold text-lg tracking-tight text-[#0B1533]">{s.title}</h3>
                <p className="font-body text-sm text-[#5A607A] mt-2 leading-relaxed flex-1">{s.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-body text-sm font-semibold text-[#2B4BFF]">
                  Mehr erfahren <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-200" />
                </span>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesDetail;
